/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthAdditionalFormType = {
    PayerForm: 'payer_form',
} as const;
export type PalReauthAdditionalFormType = typeof PalReauthAdditionalFormType[keyof typeof PalReauthAdditionalFormType];


export function instanceOfPalReauthAdditionalFormType(value: any): boolean {
    for (const key in PalReauthAdditionalFormType) {
        if (Object.prototype.hasOwnProperty.call(PalReauthAdditionalFormType, key)) {
            if (PalReauthAdditionalFormType[key as keyof typeof PalReauthAdditionalFormType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthAdditionalFormTypeFromJSON(json: any): PalReauthAdditionalFormType {
    return PalReauthAdditionalFormTypeFromJSONTyped(json, false);
}

export function PalReauthAdditionalFormTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthAdditionalFormType {
    return json as PalReauthAdditionalFormType;
}

export function PalReauthAdditionalFormTypeToJSON(value?: PalReauthAdditionalFormType | null): any {
    return value as any;
}

export function PalReauthAdditionalFormTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthAdditionalFormType {
    return value as PalReauthAdditionalFormType;
}

